import { render, staticRenderFns } from "./BarcodeTable.vue?vue&type=template&id=2be1f754&scoped=true&"
import script from "./BarcodeTable.vue?vue&type=script&lang=js&"
export * from "./BarcodeTable.vue?vue&type=script&lang=js&"
import style0 from "./BarcodeTable.vue?vue&type=style&index=0&id=2be1f754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be1f754",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2be1f754')) {
      api.createRecord('2be1f754', component.options)
    } else {
      api.reload('2be1f754', component.options)
    }
    module.hot.accept("./BarcodeTable.vue?vue&type=template&id=2be1f754&scoped=true&", function () {
      api.rerender('2be1f754', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/ProgressUpdate/BarcodeTable.vue"
export default component.exports